import React from "react";
import "./BenjamTechCV.css";

export default () => {
  return (
      <div className="BenjamTechCV">
          <div className="centerDiv">
              <h3>BenjamTech CV is an External project</h3>
              <p>BenjamTech CV is my curriculum vitae with a twist (it's encrypted)</p>
              <a target="_blank" href="https://cv.benjam.tech">CV page</a>
              <a target="_blank" href="https://github.com/benjamtech/BenjamTechCV">GitHub page</a>
          </div>
      </div>
  )
}